/* eslint-disable class-methods-use-this */
const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      button: '.js-dealer-locator',
      dlLink: '.dealer_locator_link, #dealer_locator_button',
    };

    this.classes = {
      open: 'is-open',
    };

    $(document).ready(() => {
      this.init();
      this.dealerLocatorModal();
    });
  }

  init() {
    // add domContentLoaded event listener
    this.bindClickEvent();
  }

  dealerLocatorModal() {
    const dealerLocatorLink = $(this.selectors.dlLink);

    if (dealerLocatorLink.length) {
      dealerLocatorLink.on('click', e => {
        let url = e.currentTarget.href;

        if (!url) {
          url = e.target.href;
        }

        if (url.match(/yanmar\.com\/global\/dealerlocator/)) {
          e.preventDefault();
          this.processDealerLocatorUrl(url);
        }
      });
    }

    document.addEventListener('dealerLocatorMarker', e => {
      const url = e.detail?.object?.link;

      this.processDealerLocatorUrl(url);
    });
  }

  processDealerLocatorUrl(url) {
    if (!url) {
      return;
    }

    if ($.featherlight) {
      $.featherlight({
        iframe: url,
        afterContent() {
          const $content = this.$instance[0];
          const $iframe = this.$content;

          $iframe.wrap(`<div class="iframe-wrap"></div>`);
          const wrap = $($content).find('.iframe-wrap');
          // const bottom = wrap.css('bottom');
          // wrap.css('bottom', '0');

          setTimeout(() => {
            wrap.addClass('has-loaded');
            // wrap.css('bottom', bottom);
          }, 100);
        },
      });
    } else {
      window.open(url, '_blank');
    }
  }

  bindClickEvent() {
    const button = $(this.selectors.button);
    button.on('click', () => {
      button.toggleClass(this.classes.open);
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/dealer-locator.js